module.exports = __webpack_public_path__ + "static/media/machineLearning.63e8af98.jpg";